import { Ref, useEffect, useRef, useState } from 'react';

export type Option = {
  label: string;
  value: string | number;
};
type SelectionProps = {
  options: Option[];
  selected: Option;
  onChange: (value: Option) => void;
  className?: string;
};

const Selection = ({ options, selected, className = '', onChange = () => {} }: SelectionProps) => {
  const ref: Ref<HTMLDivElement> = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (value: Option) => {
    onChange(value);
    setIsOpen(false);
  };
  const onClickOutside = (e: Event) => {
    if (ref?.current && !ref?.current?.contains(e?.target as Node)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('mousedown', onClickOutside);
    return () => {
      window.removeEventListener('mousedown', onClickOutside);
    };
  }, []);

  return (
    <div
      className={`h-[57px] border rounded-[3px] relative after:content-[''] after:absolute after:border-b-[0px] after:border-t-[6px] after:border-x-[6px] 
      after:border-x-transparent after:border-t-black  after:top-[50%] after:right-[7px] after:translate-y-[-50%] cursor-pointer ${className}`}
      onClick={() => setIsOpen(!isOpen)}
    >
      <div
        className="block text-ellipsis h-full truncate esp_print_format ml-2 mr-7 leading-[57px] text-[#333]"
        title={selected.label}
      >
        {selected.label || '選択してください'}
      </div>
      {isOpen && (
        <div className="absolute top-[100%] border w-[100%] bg-white rounded-[3px] overflow-hidden" ref={ref}>
          {options.map((option: Option, index: number) => (
            <p
              title={option.label}
              className={
                'block truncate p-4 text-ellipsis hover:text-white cursor-pointer hover:bg-[#a8d08d66] ' +
                (option.value === selected.value ? 'bg-[#a8d08d] text-white' : '')
              }
              key={index}
              onClick={() => handleChange(option)}
            >
              {option.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default Selection;
